import type { ScheduleChangesFeedStatus } from "./ScheduleChangesContext";

type FeedQueryState = {
	/** An admin with a department and a window — the query is asked at all. */
	isActive: boolean;
	/** The query holds an answer for the current window (possibly from before a failed poll). */
	hasData: boolean;
	isError: boolean;
};

/**
 * The feed as the Changes tab must treat it. `ready` whenever there is an answer — a poll that failed after a good
 * load keeps showing it — so only a first load decides `loading` vs `error`.
 */
export const feedStatusOf = ({ isActive, hasData, isError }: FeedQueryState): ScheduleChangesFeedStatus => {
	if (!isActive) return "idle";
	if (hasData) return "ready";
	return isError ? "error" : "loading";
};
